import { render, staticRenderFns } from "./CustomerFundingKA.vue?vue&type=template&id=2348b9c2&scoped=true"
import script from "./CustomerFundingKA.vue?vue&type=script&lang=ts"
export * from "./CustomerFundingKA.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFundingKA.vue?vue&type=style&index=0&id=2348b9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348b9c2",
  null
  
)

export default component.exports